// Our beloved iOS oveflow:hidedn fix
import { checkIphone, getScrollbarWidth } from "./helpers";

const body = document.body;
const isIphone = checkIphone();
const scrollbarWidth = getScrollbarWidth();
let scrollPosition = 0;
const activeLocks = new Set();

const disableScroll = (lockKey = "default") => {
    const hadLocks = activeLocks.size > 0;
    activeLocks.add(lockKey);

    if (hadLocks) {
        return;
    }

    // Save position immediately, not in RAF
    scrollPosition = window.pageYOffset;

    body.classList.add("is-overlayed");

    if (document.body.scrollHeight > window.innerHeight) {
        body.style.paddingRight = `${scrollbarWidth}px`;
    }

    // Lock position on all devices to prevent any scroll shift
    body.style.position = "fixed";
    body.style.top = `-${scrollPosition}px`;
    body.style.width = "100%";
};

const enableScroll = (lockKey = "default") => {
    activeLocks.delete(lockKey);

    // Only unlock once every overlay that locked scroll has been closed
    if (activeLocks.size > 0) {
        return;
    }

    // Get position from body top style (more reliable than saved variable)
    const savedTop = body.style.top;
    const restoredPosition = savedTop ? parseInt(savedTop, 10) * -1 : scrollPosition;

    // Remove fixed positioning
    body.style.removeProperty("position");
    body.style.removeProperty("top");
    body.style.removeProperty("width");
    body.style.removeProperty("padding-right");

    // Restore scroll immediately with instant behavior
    window.scrollTo({
        top: restoredPosition,
        left: 0,
        behavior: "instant",
    });

    // Remove overlay class after scroll is set
    body.classList.remove("is-overlayed");
};

export { disableScroll, enableScroll };
